export const MONITORING_QUEUE_ENTRY_TYPES = {
  WATCHLIST_MANUAL_SEARCH: 1,
  WATCHLIST_REGULAR_SEARCH: 2,
  API_SCORING: 3,
  BATCH_SCORING: 4,
  REGULAR_SCORING: 5,
};

export const typeOptions = [
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH,
    label: "Watchlist manual search",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH,
    label: "Watchlist regular search",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.API_SCORING,
    label: "API scoring",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING,
    label: "Batch scoring",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING,
    label: "Regular scoring",
  },
];

export const MONITORING_QUEUE_RISK_LEVEL_TYPES = {
  NORMAL_RISK: "Normal",
  MEDIUM_RISK: "Medium",
  HIGH_RISK: "High",
};

export const riskLevelOptions = [
  {
    value: MONITORING_QUEUE_RISK_LEVEL_TYPES.NORMAL_RISK,
    label: "Normal risk",
  },
  {
    value: MONITORING_QUEUE_RISK_LEVEL_TYPES.MEDIUM_RISK,
    label: "Medium risk",
  },
  {
    value: MONITORING_QUEUE_RISK_LEVEL_TYPES.HIGH_RISK,
    label: "High risk",
  },
];

export const MONITORING_QUEUE_STATUS_TYPES = {
  PENDING: 1,
  REJECTED_HIGH_RISK: 2,
  ESCALATED: 3,
  APPROVED_HIGH_RISK: 4,
  APPROVED_MEDIUM_RISK: 5,
  APPROVED_NORMAL_RISK: 6,
};

export const statusOptions = [
  {
    value: MONITORING_QUEUE_STATUS_TYPES.PENDING,
    label: "Pending",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.REJECTED_HIGH_RISK,
    label: "Rejected High Risk",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.ESCALATED,
    label: "Escalated",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.APPROVED_HIGH_RISK,
    label: "Approved High Risk",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.APPROVED_MEDIUM_RISK,
    label: "Approved Medium Risk",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.APPROVED_NORMAL_RISK,
    label: "Approved Normal Risk",
  },
];

export const MONITORING_QUEUE_WATCHLIST_MATCH_TYPES = {
  YES: true,
  NO: false,
};

export const watchListMatchOptions = [
  {
    value: MONITORING_QUEUE_WATCHLIST_MATCH_TYPES.YES,
    label: "Yes",
  },
  {
    value: MONITORING_QUEUE_WATCHLIST_MATCH_TYPES.NO,
    label: "No",
  },
];

export const MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES = {
  INITIAL: 0,
  FALSE_POSITIVE: 1,
  TRUE_MATCH: 2,
};

export const watchListMatchStatusOptions = [
  {
    value: MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES.INITIAL,
    label: "In Review",
    key: 0,
  },
  {
    value: MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES.FALSE_POSITIVE,
    label: "False Positive",
    key: 1,
  },
  {
    value: MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES.TRUE_MATCH,
    label: "True Match",
    key: 2,
  },
];

export const CLIENT_REPORT_FILTERS = {
  categoryType: "Category Type:",
  clientName: "Name:",
  clientNumber: "EGN / Company number:",
};



// WEBPACK FOOTER //
// ./src/features/client-profile/constants/clientProfileEntryConstants.js